// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const content = "FAQ__content__o+CWG";
export const emailSection = "FAQ__emailSection__J4T7W ContentsBased__section__2U6EQ font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const tableOfContentsWrapper = "FAQ__tableOfContentsWrapper__3NTW1 ContentsBased__tableOfContentsWrapper__qIwdZ";